import * as Icons from "lucide-react";
import { STATUS_META } from "./reviewMeta";
import { StatusDot } from "./StatusDot";

// model = { activeMeta, activeIdx, keysLength, activeStatus, activeK, isFlagged, markReviewedLabel }
// actions = { onPrev, onNext, onToggleAttention, onMarkReviewed }
export function ReviewSectionContainer({ model, actions, children }) {
  const { activeMeta, activeIdx, keysLength, activeStatus, activeK, isFlagged, markReviewedLabel } = model;
  const ActiveIcon = Icons[activeMeta.icon] || Icons.FileText;
  const activeStatusMeta = STATUS_META[activeStatus];

  return (
    <div className="rounded-2xl border border-slate-200 bg-white overflow-hidden flex flex-col" data-testid="ca-center">
      <div className="px-5 py-3.5 border-b border-slate-100 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2.5 min-w-0">
          <ActiveIcon className="h-5 w-5 text-blue-600 shrink-0" />
          <div className="min-w-0">
            <h2 className="text-base font-bold text-slate-900 truncate">{activeMeta.label}</h2>
            <div className="text-[11px] text-slate-400">Section {activeIdx + 1} of {keysLength}</div>
          </div>
        </div>
        <span className={`inline-flex items-center gap-1.5 text-[11px] font-semibold px-2.5 py-1 rounded-full border ${activeStatusMeta.pill}`} data-testid="ca-active-status">
          <StatusDot status={activeStatus} size="h-3 w-3" />{activeStatusMeta.label}
        </span>
      </div>
      <div className="p-5 overflow-y-auto" style={{ maxHeight: "calc(100vh - 320px)" }}>{children}</div>
      <div className="px-5 py-3 border-t border-slate-100 bg-slate-50/60 flex items-center justify-between gap-2 flex-wrap">
        <div className="flex items-center gap-2">
          <button onClick={actions.onPrev} disabled={activeIdx === 0} data-testid="ca-prev" className="inline-flex items-center gap-1 text-sm text-slate-600 hover:text-slate-900 disabled:opacity-40 disabled:cursor-not-allowed"><Icons.ChevronLeft className="h-4 w-4" />Previous</button>
          <span className="text-slate-300">·</span>
          <button onClick={actions.onNext} disabled={activeIdx === keysLength - 1} data-testid="ca-next" className="inline-flex items-center gap-1 text-sm text-slate-600 hover:text-slate-900 disabled:opacity-40 disabled:cursor-not-allowed">Next<Icons.ChevronRight className="h-4 w-4" /></button>
        </div>
        {activeK !== "approval" && (
          <div className="flex items-center gap-2">
            <button onClick={actions.onToggleAttention} data-testid="ca-flag" className={`inline-flex items-center gap-1.5 rounded-lg border px-3 py-2 text-xs font-semibold ${isFlagged ? "border-amber-300 bg-amber-50 text-amber-700" : "border-slate-200 text-slate-500 hover:bg-slate-100"}`}>
              <Icons.Flag className="h-3.5 w-3.5" />{isFlagged ? "Flagged" : "Flag"}
            </button>
            <button onClick={actions.onMarkReviewed} data-testid="ca-mark-reviewed" className="inline-flex items-center gap-1.5 rounded-lg bg-slate-900 hover:bg-slate-800 text-white px-4 py-2 text-sm font-semibold">
              <Icons.Check className="h-4 w-4" />{markReviewedLabel}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
